import { BodyType } from '../../../../api/types';
import useValidator from '../../../../utilities/useValidator';
import validators from '../../../../utilities/validators';

const validator = validators.compose(
    validators.requiredString('identifier'),
    validators.requiredString('name.defaultValue'),
    validators.requiredStringEnum('bodyType', BodyType),
    validators.requiredNumber('order'),
    validators.requiredBoolean('isActive')
);

const useModelValidator = () => useValidator(validator);

export default useModelValidator;
